import { v4 as uuidv4 } from "uuid";
export class ClientDeactivationReasonModel {
    constructor() {
        this.clientId = uuidv4();
        this.deactivatedReason = "";
        this.deactivationDateAsString = "";
    }
}
export default class ClientDeactivationReason extends ClientDeactivationReasonModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
